import type { State } from './reducer'
import type { ActionsNetwork } from 'shared/store/actions'
import { fetchPageData } from 'shared/store/actions'
import type { ActionPrivilegesDataResponse } from '../privileges'
import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'
import { closeWebsocket } from 'shared/store/websocket'
import { Dispatch } from 'redux'

export type ActionBlazonsDataResponse = {
    type: 'PAGE_DATA_BLAZONS_RESPONSE',
    data: State
}

type ActionBlazonsLogout = {
    type: 'LOGOUT'
}

type ActionBlazonsSigninSend = {
    type: 'SIGNIN_SEND_FORM_SUCCESS'
}

type ActionBlazonsSigninSocial = {
    type: 'SOCIAL_PENDING'
}

type ActionBlazonsSignupSend = {
    type: 'SIGNUP_SEND_FORM_SUCCESS'
}

type ActionBlazonsError = {
    type: 'BLAZONS_ERROR',
    blazonsError: boolean
}

type ActionDeleteBlazonsSuccess = {
    type: 'DELETE_BLAZON_SUCCESS'
}

type ActionDeleteBlazonsError = {
    type: 'DELETE_BLAZON_ERROR'
}

const fetchBlazonsPageData = () =>
    fetchPageData(endpoints.kingdom.blazons, 'PAGE_DATA_BLAZONS_RESPONSE')

const actionError = (blazonsError: boolean): ActionBlazonsError => ({
    type: 'BLAZONS_ERROR',
    blazonsError
})

const actionDeleteBlazonSuccess = (): ActionDeleteBlazonsSuccess => ({
    type: 'DELETE_BLAZON_SUCCESS'
})

const actionDeleteBlazonError = (): ActionDeleteBlazonsError => ({
    type: 'DELETE_BLAZON_ERROR'
})

const deleteBlazon = (id: string) => {
    return async (dispatch: Dispatch<any>) => {
        try {
            await ws.put(`${endpoints.kingdom.blazons}/${id}/_deactivate`)
            dispatch(fetchBlazonsPageData())
            dispatch(actionDeleteBlazonSuccess())
            return true
        } catch (error) {
            const { response } = error
            console.error('Error deleting profile', response)
            dispatch(actionDeleteBlazonError())
        }
    }
}

export { actionError, fetchBlazonsPageData, deleteBlazon }

export type Action =
    | ActionBlazonsDataResponse
    | ActionBlazonsLogout
    | ActionBlazonsSigninSend
    | ActionBlazonsSigninSocial
    | ActionBlazonsSignupSend
    | ActionBlazonsError
    | ActionPrivilegesDataResponse
    | ActionsNetwork
